import React from "react";
import unsw from './../assets/logo/unsw.png';
import TYUT from './../assets/logo/TYUT.png';
import USTB from './../assets/logo/USTB.png';
import UoA from './../assets/logo/UoA.png';
import uq from './../assets/logo/UQ.png';
import AUST from './../assets/logo/AUST.png';
import CUMT from './../assets/logo/CUMT.png';
import HPU from './../assets/logo/HPU.png';
import SDUST from './../assets/logo/SDUST.jpg';
import DKU from './../assets/logo/deakin.png';
import curtin from './../assets/logo/curtin_uni.png';
import WSU from './../assets/logo/WSU.png';
import YUT from './../assets/logo/YUT.png';


const CoHost = () => {
  const co_hosts = [
    {
      pic: uq,
      url: "https://www.uq.edu.au/",
      className: "md:w-72 w-56"  // Further increased size for UQ
    },
    {
      pic: unsw,
      url: "https://www.unsw.edu.au/",
      className: "md:w-64 w-48"  // Size for UNSW
    },
    {
      pic: TYUT,
      url: "https://www.tyust.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
     {
      pic: UoA,
      url: "https://www.adelaide.edu.au/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: USTB,
      url: "https://www.ustb.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: CUMT,
      url: "https://global.cumt.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: YUT,
      url: "https://global.cumt.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: SDUST,
      url: "https://en.sdust.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: HPU,
      url: "https://en.hpu.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: AUST,
      url: "https://en.ahut.edu.cn/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: DKU,
      url: "https://www.deakin.edu.au/",
      className: "md:w-48 w-36"  // Default size
    },
    {
      pic: curtin,
      url: "https://www.curtin.edu.au/",
      className: "md:w-72 w-56"  // Default size
    },
    {
      pic: WSU,
      url: "https://www.westernsydney.edu.au/",
      className: "md:w-72 w-56"  // Default size
    },
  ];

  return (
      <div className="flex flex-row flex-wrap content-start items-center justify-around">
        {co_hosts.map((co_host, index) => (
          <a href={co_host.url} key={`co_host-${index}`} className="hover:opacity-80" target="_blank" rel="noreferrer">
            <div className={co_host.className + " m-4 md:m-8"}>

              <img className="w-full" src={co_host.pic} alt={`logo-co_host-${index}`} />
            </div>
          </a>
        ))}
      </div>
  )
}

export default CoHost;